module.exports = __webpack_public_path__ + "static/media/ICONS_IMPUESTOS.b17e388d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_IMPUESTOS.svg
// module id = 484
// module chunks = 0